module.exports = __webpack_public_path__ + "static/img/bg11.35cd07e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg11.jpg
// module id = Nesz
// module chunks = 1